import { Mail, Phone } from "lucide-react";
import { inter, philosopher } from "@/lib/fonts";
import { openExternalUrl, openMailtoLink, openTelLink } from "@/lib/capacitor";
import ButtonsHeader from "../components/common/ButtonsHeader";

export default function Help() {
  return (
    <div className="min-h-screen">
      <ButtonsHeader heading="Help Desk" showButtons={false} />

      <div className="mt-6 rounded-t-3xl px-5 pb-10 pt-8 min-h-screen bg-white">
        <div className="mb-5 flex items-center justify-between">
          <h2
            className={`text-lg font-bold text-[#0D4A5A] ${philosopher.className}`}
          >
            Raise a query
          </h2>
        </div>

        <div className="rounded-3xl border border-[#D9D9D9] bg-[#F9F9F9] px-5 py-7 text-center space-y-3 mb-3">
          <h3
            className={`text-lg font-bold leading-tight text-[#212121] ${inter.className}`}
          >
            Great! you have no
            <br />
            active queries
          </h3>
          <p className={`text-sm text-[#7A7A7A] ${inter.className}`}>
            If you are facing issues we are
            <br />
            available for your help
          </p>

          <button
            type="button"
            onClick={() => {
              void openExternalUrl("https://wa.me/919685885272");
            }}
            className={`block w-full rounded-full bg-[#C18A2A] p-4 text-md font-bold text-white ${inter.className}`}
          >
            Chat on WhatsApp
          </button>
        </div>

        <h2
          className={`mb-5 text-lg font-bold text-[#0D4A5A] ${philosopher.className}`}
        >
          Contact Details
        </h2>

        <div className="space-y-5">
          <div className="flex items-center gap-4">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#F6F0E7] shadow-sm">
              <Phone className="h-5 w-5 text-[#C18A2A]" strokeWidth={1.8} />
            </div>

            <div>
              <p
                className={`text-[0.65rem] font-bold uppercase tracking-wide text-[#A9A9A9] ${inter.className}`}
              >
                HELPLINE NUMBER
              </p>
              <button
                type="button"
                onClick={() => {
                  void openTelLink("+919685885272");
                }}
                className={`text-sm font-bold leading-tight text-[#1A1A1A] ${inter.className}`}
              >
                +91 96858 85272
              </button>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#F6F0E7] shadow-sm">
              <Mail className="h-5 w-5 text-[#C18A2A]" strokeWidth={1.8} />
            </div>

            <div>
              <p
                className={`text-[0.65rem] font-bold uppercase tracking-wide text-[#A9A9A9] ${inter.className}`}
              >
                MAIL
              </p>
              <button
                type="button"
                onClick={() => {
                  void openMailtoLink("support@muminsmart.com");
                }}
                className={`text-sm font-bold leading-tight text-[#1A1A1A] ${inter.className}`}
              >
                support@muminsmart.com
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
